
export const NOTIFICATION_SYSTEM_NAMES_MAP = new Map([
  [ 'userWarning', 'notification.userWarning' ],
  [ 'referralJoined', 'notification.referralJoined' ],
  [ 'appUpdated', 'notification.appUpdated' ],
])

export const NOTIFICATION_TIPS_NAMES_MAP = new Map([
  [ 'tipsterAddedVipTip', 'notification.tipsterAddedVipTip' ],
  [ 'tipsterAddedFreeTip', 'notification.tipsterAddedFreeTip' ],
  [ 'tipResult', 'notification.tipResult' ],
])

export const NOTIFICATION_ACTIVITY_NAMES_MAP = new Map([
  [ 'pollResult', 'notification.pollResult' ],
  [ 'pinnedContent', 'notification.pinnedContent' ],
  [ 'newPost', 'notification.newPost' ],
  [ 'eventVoteResult', 'notification.eventVoteResult' ],
])

export const NOTIFICATION_SUBSCRIPTIONS_NAMES_MAP = new Map([
  [ 'subscriptionExpired', 'notification.subscriptionExpired' ],
  [ 'newManualSubscriber', 'notification.newManualSubscriber' ],
  [ 'subscriptionActivated', 'notification.subscriptionActivated' ],
  [ 'freeTrial', 'notification.freeTrial' ],
])

export const NOTIFICATION_MESSAGES_NAMES_MAP = new Map([
  [ 'messages', 'notification.messages' ],
])
